import React, { Component } from "react";
import {
	View,
	StyleSheet,
	KeyboardAvoidingView,
	TextInput,
	Button,
	Alert,
	Platform,
	Linking,
} from "react-native";
import { translate } from "react-i18next";

import Webview from "views/DeviceAuth/Webview";
import StatusBar from "components/StatusBar";
import Header from "components/Header";
import KeyboardView from "components/KeyboardView";
import BackgroundImage from "components/BackgroundImage";
import Text from "components/StyledText";
import { DeviceRegisterIP, AppURL } from "utils/config";
import { push } from "utils/navigation";
import { Storage } from "utils/storage";

import * as x from "../../styles/css";

class DeviceAuth extends Component {
	static navigationOptions = {
		header: null,
	};

	static isPrivate = true;
	static bypass = true;

	constructor(props) {
		super(props);

		this.connected = this.connected.bind(this);
	}

	connected(evt) {
		if (evt.data.startsWith("deviceId")) {
			const deviceId = evt.data.slice(evt.data.indexOf("=") + "=".length);
			setTimeout(() => {
				window.location.href = `http://${AppURL}/connect/success/${deviceId}`;
			}, 2000);
		}
	}

	render() {
		const nav = this.props.navigation;
		const { t } = this.props;

		return (
			<BackgroundImage
				resizeMode="cover"
				source={require("assets/bg.fw.jpg")}
				style={[styles.backgroundImage]}
			>
				{Platform.OS !== "web" && <StatusBar />}
				<KeyboardView style={[styles.body]}>
					<Header>{t("deviceAuth.device.title")}</Header>
					<View style={[styles.webview]}>
						<Webview
							url={DeviceRegisterIP}
							connected={this.connected}
							{...this.props}
						/>
					</View>
				</KeyboardView>
			</BackgroundImage>
		);
	}
}

const styles = StyleSheet.create({
	backgroundImage: {
		flex: 1,
		flexBasis: "auto",
		height: "100%",
	},
	webview: {
		flex: 1,
		marginTop: 40,
	},
	body: {
		flex: 1,
		...(Platform.OS === "web" ? { maxHeight: 730, minHeight: 700 } : {}),
	},
});

export default translate()(DeviceAuth);



// WEBPACK FOOTER //
// ./src/views/DeviceAuth/index.js